import { useEffect, useState } from "react";
import { useCurrentOrganisationId } from "../../../../../services/local/organisationContext/OrganisationContextModel";
import { observer } from "mobx-react-lite";
import { PositionedSpinner } from "../../../../../components/ui/PositionedSpinner";
import { TrainingTypeSettingsModel } from "./TrainingTypeSettings_model";
import { TrainingTypesGrid } from "../../../../../core/grids/builder/directorBuilder/grids/TrainingTypesGrid/TrainingTypesGridView_view";
import { Tab, Tabs } from "../../../../../components/ui/Tabs";
import "./_trainingTypes-settings.scss";
import I18n from "../../../../../core/localization/I18n";
import { Category } from "../../../../../enums";

export const TrainingTypeSettings: React.FC = observer(() => {
  const organisationId = useCurrentOrganisationId();
  const [model] = useState(() => new TrainingTypeSettingsModel(organisationId));
  const [activeTab, setActiveTab] = useState<number>(0);

  useEffect(() => {
    model.onMount();
    return model.onUnmount();
  }, [model]);

  if (model.courseLoading || model.moduleLoading || model.componentLoading) {
    return <PositionedSpinner />;
  }

  const indexToCategory: Record<number, Category> = {
    0: Category.Course,
    1: Category.Module,
    2: Category.Component
  };

  const handleTabClick = (idx?: number) => {
    if (typeof idx !== "number") return;
    setActiveTab(idx);
    const newCategory = indexToCategory[idx];
    model.setCategory(newCategory);
  };

  return (
    <Tabs
      currTabIdx={activeTab}
      onTabClicked={handleTabClick}
      className="tabs--primary trainingTypes-settings"
      ulClassName="tabs__menu--primary"
      initialTab={0}
      liClassName="tabs__item--primary"
    >
      {/** Course Types */}
      <Tab title={<h2 className="mb-0">{I18n.t("phrases.courseTypes")}</h2>}>
        <div className="insight-tab-content__space-filler" style={{ height: "100%" }}>
          <TrainingTypesGrid
            isLoading={model.courseLoading}
            data={model.courseData}
            gridToolbarType="base"
            onFieldUpdate={model.loadCourseData}
            refreshDataHandler={model.loadCourseData}
            selectedTab={Category.Course}
          />
        </div>
      </Tab>
      {/** Module Types */}
      <Tab title={<h2 className="mb-0">{I18n.t("phrases.moduleTypes")}</h2>}>
        <div className="insight-tab-content__space-filler" style={{ height: "100%" }}>
          <TrainingTypesGrid
            isLoading={model.moduleLoading}
            data={model.moduleData}
            gridToolbarType="base"
            onFieldUpdate={model.loadModuleData}
            refreshDataHandler={model.loadModuleData}
            selectedTab={Category.Module}
          />
        </div>
      </Tab>
      {/** Component Types */}
      <Tab title={<h2 className="mb-0">{I18n.t("phrases.componentTypes")}</h2>}>
        <div className="insight-tab-content__space-filler" style={{ height: "100%" }}>
          <TrainingTypesGrid
            isLoading={model.componentLoading}
            data={model.componentData}
            gridToolbarType="base"
            onFieldUpdate={model.loadComponentData}
            refreshDataHandler={model.loadComponentData}
            selectedTab={Category.Component}
          />
        </div>
      </Tab>
    </Tabs>
  );
});
